module.exports = __webpack_public_path__ + "static/media/mini.55eecd67.png";